import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TextButtonSmall = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Small Text button"}
        value={"<Button variant={\"text\"} size={'small'}>Small</Button>"}
      >
        <Button variant={"text"} size={"small"}>
          Small
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TextButtonSmall;
